import { useContext, useEffect } from 'react';
import ButtonQuestion from './ButtonQuestion';
import AppContext from '../contexts/AppContext';
import ConfigContext from '../contexts/ConfigContext';
import icons from '../data/iconsSunlight';
import { isMobile } from './../helpers';

export default function OptionsForSunlight() {
  const { slides, currentSlide, geoData, updateSelectedOption, getSlideIndex } =
    useContext(AppContext);
  const { features } = useContext(ConfigContext);
  const options = slides.find((slide: any) => slide.key === 'sunlight').options;

  useEffect(() => {
    const addressSlideNumber = getSlideIndex('addressOwnership');

    if (
      geoData?.state &&
      !slides[addressSlideNumber].additionalFields?.selectedState
    ) {
      updateSelectedOption(
        slides[addressSlideNumber].key,
        geoData.state || '',
        'selectedState'
      );
    }
  }, []);

  const renderButtonQuestions = () => {
    return options.map((option: any, index: number) => {
      const className = index !== options.length - 1 ? 'mb-4 md:mb-0' : '';
      const { path } = icons.find((icon) => icon.name === option.icon) || {};
      const { path: hoverPath } =
        icons.find((icon) => icon.name === option.iconHover) || {};

      return (
        <ButtonQuestion
          className={className}
          key={index}
          name={option.name}
          icon={path}
          iconHover={hoverPath}
          value={option.value}
          optionKey="sunlight"
          selected={slides[currentSlide].selectedValue === option.value}
          isMobileFriendly={!!features.showSunnyBotMobile}
        />
      );
    });
  };

  const renderMobileFriendlyOptions = () => {
    return (
      <div className="container mt-4">
        <div className="grid grid-cols-2 gap-4">{renderButtonQuestions()}</div>
      </div>
    );
  };

  return features.showSunnyBotMobile && isMobile() ? (
    renderMobileFriendlyOptions()
  ) : (
    <div
      className={`mt-[30px] md:mt-[60px] flex justify-between ${
        features.showSunnyBot
          ? 'flex-wrap w-[320px] short:w-[320px] md:w-auto mx-auto'
          : 'flex-col md:flex-row'
      }`}>
      {renderButtonQuestions()}
    </div>
  );
}
